//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import store from "./../store";
import tweetsAPI from "./../apis/tweets";
import { fromNowFilter } from "./../utils/mixins";
import { Toast } from "./../utils/helpers";

export default {
  name: "Tweets",
  mixins: [fromNowFilter],
  props: {
    initialTweet: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tweet: this.initialTweet,
      isLiked: false,
    };
  },
  methods: {
    async likeTweet(id) {
      try {
        const { data } = await tweetsAPI.likeTweets(id);

        if (data.status === "error") {
          throw new Error(data.message);
        }

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        this.$emit("update-tweet");
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
    async unlikeTweet(id) {
      try {
        const { data } = await tweetsAPI.unLikeTweets(id);

        if (data.status === "error") {
          throw new Error(data.message);
        }

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        this.$emit("update-tweet");
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
  },
};
